import { useMutation, useQueryClient } from "@tanstack/vue-query";
import BusinessProfileService from "@/services/organization/business-profile";

export function useSubmitBusinessProfile() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      const result = await BusinessProfileService.submitBusinessProfile();
      if (result.data?.status === false) {
        throw new Error(
          result.data.message || "Failed to submit business profile for verification"
        );
      }
      return result.data?.data ?? result.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["businessProfile"] });
    },
  });
}
